import React, { useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';

function SgCEPAddonContent(props) {
    const {
        addon,
        contentMessages
    } = props;
    const translator = useContext(TranslatorContext);

    return (
        <>
            <div className={`sg-add-on-icon-container ${addon.selected ? 'sg-addon-selected' : ''}`}>
                <div
                    className={`sg-add-on-icon-box sg-add-on-icon_${addon.patternCode}`}
                    aria-hidden="true"
                />
                <div className="sg-addon-icon-added">&nbsp;</div>
            </div>
            <div id={`coverageHeader_${addon.patternCode}`} className="sg-add-on-name">
                {translator(contentMessages.Name)}
            </div>
            <div className="sg-add-on-description-box">
                {translator(contentMessages.Description, contentMessages.Params)}
            </div>
        </>
    );
}

export default SgCEPAddonContent;
